<template>
  <section class="edit-modal">
    <vyModal
      class="row-edit-modal"
      v-if="showEditModal"
      :submit-label="'Update ' + objectName"
      :headerTitle="'Edit ' + objectName"
      @cancel="$emit('finished')"
      @close="dismissIfNoChanges"
      :outsideClickWhitelist="['fas',  'fal',  'far', 'fa-times-circle', 'delete']"
      @submit="updateRow"
    >
      <div slot="body">
        <v-form @submit.prevent>
          <v-container v-for="(column, i) in columns" :key="i">
            <v-row>
              <v-col cols="3">
                <div class="columnTitle">{{ column.name }}:</div>
              </v-col>
              <v-col cols="9" class="columnValue">
                <input
                  type="text"
                  v-if="column.type === 'STRING'"
                  v-model="updatedRow[column.id]"
                  class="rowValueInput"
                />
                <input
                  type="number"
                  v-if="column.type === 'NUMBER'"
                  v-model="updatedRow[column.id]"
                  :min="column.minValue"
                  :max="column.maxValue"
                  class="rowValueInput"
                />
                <v-switch
                  v-if="column.type === 'BOOLEAN' || column.type === 'BOOLEAN_Y_N'"
                  v-model="updatedRow[column.id]"
                />
                <span v-if="column.type === 'BUILDING'" class="buildingContainer">
                  {{ updatedRow[column.id] || editingRow[column.id] }}

                  <v-btn
                    v-if="column.type === 'BUILDING'"
                    color="primary"
                    outlined
                    class="buildingSelectButton"
                    @click="selectedBuilding=  undefined; showSelectionModal = true;"
                  >Select Different Building...</v-btn>
                  <vyModal
                    class="selection-table-modal"
                    v-if="showSelectionModal"
                    headerTitle="Select Building"
                    :outsideClickWhitelist="['fas',  'fal',  'far', 'fa-times-circle', 'delete']"
                    @cancel="showSelectionModal = false"
                    @close="showSelectionModal = false"
                    @submit="handleBuildingUpdated(column.id)"
                  >
                    <div slot="body">
                      <data-selection-table
                        :columns="buildingsFilterColumns"
                        :filterColumns="buildingsColumns"
                        :datasetMetadata="buildingsMetadata"
                        :queryFunction="buildingsQueryFunction"
                        :dataIndex="buildingsDataIndex"
                        :displayField="buildingsDisplayField"
                        datasetName="buildings"
                        :maxSelections="1"
                        @selections-updated="handleBuildingSelected"
                      ></data-selection-table>
                    </div>
                  </vyModal>
                </span>
                <v-alert v-if="validationMessages[column.id]" type="warning">
                  {{ validationMessages[column.id] }}
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
          <v-alert v-if="error" type="error">{{ error }}</v-alert>
        </v-form>
      </div>
      <div slot="footer">
        <button class="btn btn-default cancel-button" @click="$emit('finished')">Cancel</button>
        <button
          class="btn btn-primary ok-button"
          @click="updateRow"
          :disabled="!isEditDifferent"
        >
          Update {{ objectName }}
        </button>
      </div>
    </vyModal>
  </section>
</template>
<script>
import Modal from '../../modal/src/modal.vue';
import DataSelectionTable from '../../dataSelectionTable/src/dataSelectionTable.vue';
import FilterExpressionService from '../../../modules/assurance/services/filter.expression.service';
import MetadataService from '../../../services/metadata.service';
import VueDatasetService from '../../../services/vue-dataset-view.service';

const BOOL_TYPE = 'BOOLEAN'
const NUMBER_TYPE = 'NUMBER';
const STRING_TYPE = 'STRING';

export default {
  name: 'EditModal',
  props: {
    columns: { type: Array, required: true },
    editingRow: { type: Object, required: true },
    objectName: { type: String, required: true },
    primaryKey: { type: String },
    saveService: { type: Function },
    showEditModal: { type: Boolean, default: false },
  },
  data: function() {
    return {
      buildingsMedata: undefined,
      buildingsColumns: undefined,
      buildingsDataIndex: undefined,
      buildingsDisplayField: undefined,
      buildingsFilterColumns: undefined,
      error: '',
      selectedBuilding: undefined,
      showSelectionModal: false,
      updatedRow: structuredClone(this.editingRow),
      validationMessages: {},
    };
  },
  computed: {
    isEditDifferent: function() {
      let changed = false;
      Object.keys(this.editingRow).forEach((key) => {
        if (this.editingRow[key] !== this.updatedRow[key]) {
          changed = true;
        }
      });
      return changed;
    },
  },
  watch: {
    editingRow: function() {
      this.updatedRow = structuredClone(this.editingRow);
      this.validationMessages = {};
    }
  },
  components: {
    'data-selection-table': DataSelectionTable,
    'vyModal': Modal,
  },
  methods: {
    buildingsQueryFunction: function(page, filterExpression, sorters) {
      let self = this;

      return new Promise((resolve, reject) => {
        let params = {
          page,
          filter: FilterExpressionService.getFilterStringFromFilterExpression(filterExpression),
          size: 20, // todo this should use the data-selection-table pageSize
          sort: VueDatasetService.getSortParam(sorters)
        };

        VueDatasetService.getDataset('buildings', params).then(responseData => {
          resolve({
            data: responseData.content,
            last_page: responseData.totalPages,
            total_count: responseData.totalCount
          })
        });
      });
    },

    dismissIfNoChanges() {
      if (!this.isEditDifferent) {
        this.$emit('finished');
      }
    },

    handleBuildingSelected(data) {
      if (data.length === 1) {
        this.selectedBuilding = data[0].buildingKey;
      }
    },

    handleBuildingUpdated(key) {
      if (this.selectedBuilding) {
        this.updatedRow[key] = this.selectedBuilding;
      }
      this.showSelectionModal = false;
    },

    updateRow: async function() {
      if (this.validateColumns() === true) {
        return;
      }
      let currentService = this.saveService;
      let primaryKey = this.primaryKey || id;
      let parsedRow = {};
      Object.keys(this.updatedRow).forEach(key => {
        if (this.updatedRow[key] !== this.editingRow[key]) {
          let splitKey = key.split('.');
          let localKey;
          if (splitKey.length > 1) {
            localKey = splitKey[1];
          } else {
            localKey = splitKey[0];
          }
          parsedRow[localKey] = this.updatedRow[key];
        }
      });
      let response = await currentService.updateTableRow(this.editingRow[primaryKey], parsedRow);
      if (response && response.status === 200) {
        this.error = '';
        this.$emit('finished');
        if (typeof this.reloadData === 'function') {
          this.reloadData();
        }
      } else {
        if (response && response.data && response.data.detail) {
          this.error = response.data.detail;
        } else {
          this.error = 'Error saving ' + this.objectName;
        }
      }
    },
    validateColumns() {
      let validationError = false;
      this.columns.forEach(column => {
        this.validationMessages[column.id] = '';
        let value = this.updatedRow[column.id];
        if (column.type === STRING_TYPE) {
          let regex = new RegExp(column.regex);
          let valid = regex.test(value);
          if (!valid) {
            validationError = true;
            this.validationMessages[column.id] = 'Incorrect format';
          }
        }
        else if (column.type === NUMBER_TYPE) {
          let min = column.minValue;
          let max = column.maxValue;
          if (value < min || value > max) {
            validationError = true;
            if (typeof min === 'number' && typeof max === 'number') {
              this.validationMessages[column.id] = 'Value must be ' + min + ' - ' + max;
            } else if (typeof min === 'number') {
              this.validationMessages[column.id] = 'Value must be ' + min + ' or greater';
            } else if (typeof max === 'number') {
              this.validationMessages[column.id] = 'Value must be ' + max + ' or less';
            }
          }
        }
      });
      this.$forceUpdate();
      return validationError;
    },

    loadMetadata() {
        var self = this;
        return MetadataService.fetchDatasetMetadataWithoutCategories().then(responseMetadata => {
          self.buildingsMetadata = responseMetadata.find(config => config.id.toLowerCase() === 'buildings');
          self.buildingsColumns = VueDatasetService.convertColumns(self.buildingsMetadata.columns, undefined, true);
          self.buildingsDataIndex = self.buildingsMetadata.indexColumn;
          self.buildingsDisplayField = self.buildingsMetadata.nameColumn;
          self.buildingsFilterColumns = self.buildingsColumns.filter(column => !column.invisible);
        });
    },
  },
  mounted: function() {
    this.loadMetadata();
  }
}
</script>
<style lang="scss">
.edit-modal {
  .modal-container {
    max-height: 90vh;
    overflow: hidden;

    .modal-subheader {
      font-weight: bold;
      font-size: 16px;;
    }

    .modal-header div {
      position: relative;
      h1 {
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        line-height: 35px;
      }
      .text-xs-right {
        position: absolute;
        right: -5px;
        top: -10px;

        .close-icon {
          cursor: pointer;
        }
      }
    }
  }
  .row-edit-modal {
    .columnTitle {
      padding-top: 20px;
      height: 50px;
      text-align: right;
      font-weight: 700;
    }
    .columnValue {
      .rowValueInput {
        height: 40px;
        border: 1px solid darkgray;
        border-radius: var(--text-input-border-radius);
        padding: 5px;
        width: 500px;
        margin: 10px 0;
      }

      .v-alert {
        font-size: 14px;
        padding: 10px;
        width: 500px;
        margin-left: 10px;
        .v-icon {
          font-size: 18px;
        }
      }
    }
    .buildingContainer {
      display: flex;
      margin-top: 5px;
      align-items: center;

      .buildingSelectButton {
        margin: 5px;
        font-size: 14px;
        font-weight: 600;
        height: 40px;
        min-width: 198px!important;
        max-width: 100%;
        letter-spacing: unset;
        color: #FFFFFF;
        text-transform:none;
        border-radius:6px;
        box-shadow:none;
      }
    }
    .modal-body {
      max-height: 425px;
      overflow-y: auto;
    }
    .modal-footer {
      button {
        margin: 0 10px;
      }
    }
  }
}
</style>